module.exports = __webpack_public_path__ + "static/paths-to-wealth-through-common-stocks-fcb51d6a390ad16871d8a8eb5666853e.jpg";